var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Barbados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M44,24c0-8.199-4.939-15.237-12-18.325v36.649C39.061,39.237,44,32.199,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M4,24c0,8.199,4.939,15.237,12,18.325V5.675C8.939,8.763,4,15.801,4,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M32,5.675C29.549,4.604,26.846,4,24,4s-5.549,0.604-8,1.675v36.649C18.451,43.396,21.154,44,24,44 s5.549-0.604,8-1.675V5.675z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.887,20.008c-1.109,0.18-2.254,0.781-3.039,1.621c-0.09,0.113,0.484-0.125,0.535-0.137 c0.43-0.133-0.125,0.629-0.156,0.824c-0.441,1.457-0.824,2.859-0.965,4.535c0,0.113-0.02,0.195-0.07,0.203l-1.473-0.227v-5.387 c0.344-0.008,0.883,0.086,1.191,0.191C24.918,20.613,24.453,19.281,24,18c-0.453,1.281-0.918,2.613-1.91,3.633 c0.309-0.105,0.848-0.199,1.191-0.188v5.383l-1.473,0.227c-0.051-0.004-0.07-0.09-0.07-0.203c-0.141-1.672-0.523-3.078-0.965-4.531 c-0.031-0.199-0.59-0.957-0.156-0.824c0.051,0.008,0.625,0.25,0.535,0.133c-0.785-0.836-1.93-1.441-3.039-1.617 c-0.102-0.027-0.16,0.023-0.07,0.141c1.477,2.348,2.711,5.117,2.699,8.402c0.574,0,1.965-0.352,2.539-0.352V32h1.438v-3.801 c0.574,0,1.965,0.352,2.539,0.352c-0.012-3.285,1.223-6.055,2.699-8.398C30.047,20.031,29.984,19.98,29.887,20.008z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Barbados);
export default __webpack_public_path__ + "static/media/icons8-barbados.362e530b715c0e7f7c7b496fea1dceb8.svg";
export { ForwardRef as ReactComponent };